import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { environment } from './../../../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class CustomerDetailService {
    private urlPrefix: string = environment.appUrl;
    constructor(
        private http: Http,
        private httpClient: HttpClient
    ) { }

    getDetail(id): Observable<any> {
        const url = this.urlPrefix + 'customers/' + id  ;
        return this.httpClient
            .get(url,
                {
                    observe: 'response'
                })
            .map(
                res => {
                    if (res.status === 200) {
                        return res.body;
                    } else {
                        return Observable.throw(null);
                    }
                }
            )
            .catch(
                err => {
                    return Observable.throw(err);
                }
            );
    }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/customer/customer-detail/customer-detail.service.ts